import React from 'react';
import { ActivityIcon, CalendarRangeIcon, HeartPulseIcon, LayersIcon, LineChartIcon, MessageSquareQuoteIcon } from 'lucide-react';
import { packItems } from '../data/content';
const icons = {
  mastery: LayersIcon,
  clinical: HeartPulseIcon,
  flows: CalendarRangeIcon,
  cueing: MessageSquareQuoteIcon,
  anatomy: ActivityIcon,
  tracker: LineChartIcon
};
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-209" data-mp="b5de21t5gx32">
      <div className="mx-auto max-w-4xl" data-id="element-210" data-mp="fxof57zmmox7">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-211" data-mp="fyppfa8tj7dv">
          What&apos;s Inside the PILATES READY™ Pack?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-212" data-mp="75copm4ij1h8">
          {packItems.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex flex-col rounded-2xl bg-sand px-6 py-8 text-center" data-id="element-213" data-mp="3tazuuli6b192">
                <span className="mx-auto inline-flex h-10 w-10 items-center justify-center rounded-full bg-white text-brand" data-id="element-214" data-mp="3cvqv4nxgfjga">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-215" data-mp="3lv45rjxbee2l" />
                </span>
                <h3 className="mt-4 font-display text-base font-bold leading-snug text-ink" data-id="element-216" data-mp="3hta6ng2rpi4j">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-ink/55" data-id="element-217" data-mp="2u47sii7ce7es">
                  {item.text}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}